<div class="u-flex-full">
  <label>{{value?.id}} </label>
  <button class="close" *ngIf="value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
    (click)="clearActionAttachment()">
    <mat-icon>close</mat-icon>
  </button>
</div>